import React, { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { useRecoilState, useRecoilValue } from "recoil";
import { isModalAtom, idxAtom, isContents } from "../../atoms";
//import axios from "axios";

function LoginModal() {
  //모달 닫기 제어
  const idxnum = useRecoilValue(idxAtom);
  const [data] = useRecoilState(isContents);
  //const [, setPosts] = useRecoilState(isBoard);
  const [, setisMocalopen] = useRecoilState(isModalAtom);
  const handleClose = () => setisMocalopen(false);

  useEffect(() => {
    /*    axios.get(`/api/board/detail/${idxnum}`).then((response) => {
      setData(response.data);
    });
    // data가 변할 때마다 아래의 코드가 실행됩니다.
    axios.get(`/api/board/list`).then((response) => {
      setPosts(response.data);
    });
*/
  }, []);

  return (
    <>
      <Modal.Header>
        {idxnum}
        <Modal.Title>{data.title}</Modal.Title>
        <small>{data.view_count}</small>
      </Modal.Header>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: data.content }}></div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn_close" variant="secondary" onClick={handleClose}>
          닫기
        </Button>
      </Modal.Footer>
    </>
  );
}

export default LoginModal;
